var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"purchase-history-view"},[_c('h2',[_vm._v("Purchase History")]),_c('p',[_vm._v("This is the purchase history view.")])])
}]

export { render, staticRenderFns }